let $illustrationPlanning = null;
let $linesBottom = null;
let $linesBottomAnimated = null;
let $lines = null;
let $linesAnimatedPaths = null;
let $controlRoom = null;
let $controlRoomAnimated = null;
let $controlRoomFrame = null;
let $terminal = null;
let $terminalAnimated = null;
let $terminalScreen = null;
let $terminalScreenOverlay = null;
let $phone = null;
let $phoneAnimated = null;
let $phoneScreen = null;
let $phoneScreenOverlay = null;
let $circleMask = null;
let $circleBorder = null;
let $light = null;
let $lightAnimated = null;
let $manFill = null;
let $manBorder = null;
let $circleEl = null;

const duration = 0.65;
const circleAndManAnimatedColor = '#e0a672';

let animation = null;

const pause = () => {
	if (animation && !animation.paused()) {
		animation.pause();
	}
};

const play = () => {
	if (animation && animation.paused()) {
		animation.play();
	}
};

const create = () => {
	if (animation || !$illustrationPlanning) {
		return;
	}

	const terminalScreenTimeline = gsap.timeline({repeat: -1});
	const phoneScreenTimeline = gsap.timeline({repeat: -1});
	const terminalScreenDuration = 0.15;
	const phoneScreenDuration = 0.15;
	const terminalScreenDelay = 1;
	const phoneScreenDelay = 1;

	animation = gsap
		.timeline({
			delay: 0.5,
			paused: true,
		})
		.to($linesBottom, {
			duration,
			opacity: 0,
		}, 0.75)
		.to($linesBottomAnimated, {
			duration,
			opacity: 1,
		}, 0.75)
		.to($linesAnimatedPaths, {
			duration: duration * 3,
			strokeDashoffset: 0,
		}, 0.75)
		.to($lines, {
			duration,
			opacity: 0,
		}, '>')
		.to([$controlRoomAnimated, $terminalAnimated, $phoneAnimated], {
			duration,
			stagger: duration,
			opacity: 1,
		}, 2)
		.to([$terminal, $phone], {
			duration,
			stagger: duration,
			opacity: 0,
		}, '>')
		.to($controlRoomFrame, {
			duration,
			opacity: 0,
		}, 2)
		.to([$terminalScreen[0], $phoneScreen[0]], {
			duration,
			stagger: duration,
			opacity: 1,
		}, 2 + duration)
		.to([$terminalScreenOverlay, $phoneScreenOverlay], {
			duration,
			stagger: duration,
			opacity: 1,
		}, 2 + duration)
		.to($phone, {
			duration,
			yPercent: 0,
		}, 0)
		.to($circleMask, {
			duration,
			strokeDashoffset: 0,
		}, 0)
		.to($circleEl, {
			duration: 30,
			rotate: 360,
			ease: 'none',
			repeat: -1,
		}, duration)
		.to($circleBorder, {
			duration,
			stroke: circleAndManAnimatedColor,
		}, 3.75)
		.to($light, {
			duration,
			opacity: 1,
		}, 1.35)
		.to($light, {
			duration,
			opacity: 0,
		}, 3.75)
		.to($lightAnimated, {
			duration,
			opacity: 1,
		}, 3.75)
		.to($manFill, {
			duration,
			opacity: 0.5,
		}, 1.35)
		.to($manBorder, {
			duration,
			stroke: circleAndManAnimatedColor,
		}, 1.35);

	terminalScreenTimeline
		.to($terminalScreen[0], {
			duration: terminalScreenDuration,
			delay: terminalScreenDelay,
			opacity: 0,
		})
		.to($terminalScreen[1], {
			duration: terminalScreenDuration,
			opacity: 1,
		}, '<')
		.to($terminalScreen[1], {
			duration: terminalScreenDuration,
			delay: terminalScreenDelay,
			opacity: 0,
		})
		.to($terminalScreen[2], {
			duration: terminalScreenDuration,
			opacity: 1,
		}, '<')
		.to($terminalScreen[2], {
			duration: terminalScreenDuration,
			delay: terminalScreenDelay,
			opacity: 0,
		})
		.to($terminalScreen[3], {
			duration: terminalScreenDuration,
			opacity: 1,
		}, '<')
		.to($terminalScreen[3], {
			duration: terminalScreenDuration,
			delay: terminalScreenDelay,
			opacity: 0,
		})
		.to($terminalScreen[0], {
			duration: terminalScreenDuration,
			opacity: 1,
		}, '<');

	phoneScreenTimeline
		.to($phoneScreen[0], {
			duration: phoneScreenDuration,
			delay: phoneScreenDelay,
			opacity: 0,
		})
		.to($phoneScreen[1], {
			duration: phoneScreenDuration,
			opacity: 1,
		}, '<')
		.to($phoneScreen[1], {
			duration: phoneScreenDuration,
			delay: phoneScreenDelay,
			opacity: 0,
		})
		.to($phoneScreen[2], {
			duration: phoneScreenDuration,
			opacity: 1,
		}, '<')
		.to($phoneScreen[2], {
			duration: phoneScreenDuration,
			delay: phoneScreenDelay,
			opacity: 0,
		})
		.to($phoneScreen[0], {
			duration: phoneScreenDuration,
			opacity: 1,
		}, '<');

	animation
		.add(terminalScreenTimeline, 3.5)
		.add(phoneScreenTimeline, 4);
};

const reset = () => {
	$illustrationPlanning = document.querySelector('.illustration-planning');
	$linesBottom = document.querySelector('.illustration-planning__element--lines-bottom img:first-child');
	$linesBottomAnimated = document.querySelector('.illustration-planning__element--lines-bottom img:last-child');
	$lines = document.querySelector('.illustration-planning__element--lines svg:first-child');
	$linesAnimatedPaths = document.querySelectorAll('.illustration-planning__element--lines svg:last-child path');
	$controlRoom = document.querySelector('.illustration-planning__element--control-room svg:first-child');
	$controlRoomAnimated = document.querySelector('.illustration-planning__element--control-room svg:last-child');
	$controlRoomFrame = document.querySelector('.illustration-planning__element--control-room svg:first-child .control-room-frame');
	$terminal = document.querySelector('.illustration-planning__element--terminal svg:first-child');
	$terminalAnimated = document.querySelector('.illustration-planning__element--terminal svg:last-child');
	$terminalScreen = document.querySelectorAll('.illustration-planning__element--terminal-screen svg');
	$terminalScreenOverlay = document.querySelector('.illustration-planning__element--terminal-screen-overlay');
	$phone = document.querySelector('.illustration-planning__element--phone svg:first-child');
	$phoneAnimated = document.querySelector('.illustration-planning__element--phone svg:last-child');
	$phoneScreen = document.querySelectorAll('.illustration-planning__element--phone-screen svg');
	$phoneScreenOverlay = document.querySelector('.illustration-planning__element--phone-screen-overlay');
	$circleEl = document.querySelector('.illustration-planning__element--circle');
	$circleMask = document.querySelector('.illustration-planning__element--circle .circle-mask');
	$circleBorder = document.querySelector('.illustration-planning__element--circle .circle-border');
	$light = document.querySelector('.illustration-planning__element--light svg:first-child');
	$lightAnimated = document.querySelector('.illustration-planning__element--light svg:last-child');
	$manFill = document.querySelector('.illustration-planning__element--man .man-fill');
	$manBorder = document.querySelectorAll('.illustration-planning__element--man .man-border');

	const circleTotalLength = 2 * Math.PI * $circleMask.getAttribute('r');
	const gsapElements = [
		$linesBottom,
		$linesBottomAnimated,
		$lines,
		$linesAnimatedPaths,
		$controlRoom,
		$controlRoomAnimated,
		$controlRoomFrame,
		$terminal,
		$terminalAnimated,
		$terminalScreen,
		$terminalScreenOverlay,
		$phone,
		$phoneAnimated,
		$phoneScreen,
		$phoneScreenOverlay,
		$circleMask,

		$circleBorder,
		$light,
		$lightAnimated,
		$manFill,
		$manBorder,
	];

	gsap.killTweensOf(gsapElements);

	gsap
		.timeline()
		.set([
			$linesBottomAnimated,
			$controlRoomAnimated,
			$terminalAnimated,
			$terminalScreen,
			$terminalScreenOverlay,
			$phoneAnimated,
			$phoneScreen,
			$phoneScreenOverlay,
			$light,
			$lightAnimated,
		], {opacity: 0})
		.set($phone, {yPercent: -75})
		.set($circleMask, {
			strokeDasharray: circleTotalLength,
			strokeDashoffset: circleTotalLength,
		});

	$linesAnimatedPaths.forEach(($pathCurrent) => {
		const pathTotalLength = $pathCurrent.getTotalLength();

		gsap.set($pathCurrent, {
			strokeDasharray: pathTotalLength,
			strokeDashoffset: pathTotalLength,
		});
	});

	if (animation) {
		animation.kill();

		animation = null;
	}
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	create,
	play,
	pause,
};
